// @ts-nocheck
import CheckoutForm from '../CheckoutForm/CheckoutForm';
import { Elements } from '@stripe/react-stripe-js';
import { Box } from '@mui/material';
import { createPaymentElementAppearance } from '../../../../constants/stripe';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

/**
 * Functional React component for rendering a custom booking payment component .
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the booking payment component.
 * @param {Object} [props.stripePromise] - The Promise object for Stripe.
 * @param {string} [props.clientSecret] - The client secret for Stripe.
 * @param {string} [props.paymentIntentId] - The payment intent ID for Stripe.
 * @param {string} [props.paymentMethodOrder] - The payment method order for Stripe.
 * @param {Object} [props.submitRef] - Reference to the submit button.
 *
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the booking payment component.
 */

const BookingPayment = ({
  id,
  stripePromise,
  clientSecret,
  paymentIntentId,
  paymentMethodOrder,
  selectedCurrency,
  currencyState,
  onPaymentMethodChange,
  onPaymentRecoveryChange,
  passengerFieldFiles = {},
  isZeroTotalBooking = false,
  submitRef,
  ...rest
}) => {
  const color = useSelector((state) => state?.color || {});
  const booking = useSelector((state) => state.booking || {});
  const primaryColor = color?.highlightColor || 'var(--primary-600, #1361d8)';
  const paymentAppearance = createPaymentElementAppearance(primaryColor);
  const noPaymentFlow =
    booking?.paymentOption === 'optionnopayment' || isZeroTotalBooking;
  const canRenderCheckout = Boolean(
    stripePromise && (clientSecret || noPaymentFlow)
  );

  const elementsOptions = clientSecret
    ? {
        clientSecret,
        appearance: paymentAppearance
      }
    : {
        appearance: paymentAppearance
      };

  return (
    <>
      {canRenderCheckout && (
        <Box
          id={id}
          data-testid='booking-payment'
          {...rest}
          className='book-now-modal__payment-options book-now-modal___left-panel'
        >
          <Elements
            stripe={stripePromise}
            options={elementsOptions}
            key={paymentIntentId}
          >
            <CheckoutForm
              id='booking-checkout-form'
              paymentIntentId={paymentIntentId}
              paymentMethodOrder={paymentMethodOrder}
              selectedCurrency={selectedCurrency}
              currencyState={currencyState}
              onPaymentMethodChange={onPaymentMethodChange}
              onPaymentRecoveryChange={onPaymentRecoveryChange}
              hasClientSecret={Boolean(clientSecret)}
              passengerFieldFiles={passengerFieldFiles}
              submitRef={submitRef}
            />
          </Elements>
        </Box>
      )}
    </>
  );
};

BookingPayment.propTypes = {
  clientSecret: PropTypes.string,
  id: PropTypes.string.isRequired,
  isZeroTotalBooking: PropTypes.bool,
  stripePromise: PropTypes.object,
  paymentIntentId: PropTypes.string,
  paymentMethodOrder: PropTypes.array,
  selectedCurrency: PropTypes.object,
  currencyState: PropTypes.object,
  onPaymentMethodChange: PropTypes.func,
  onPaymentRecoveryChange: PropTypes.func,
  passengerFieldFiles: PropTypes.object,
  submitRef: PropTypes.object
};

export default BookingPayment;
